/**
 * ItemList schema for the Parent Library hub (/learn and its /blog alias).
 * Loaded from a route loader so it is server-rendered without pulling the
 * article bodies into the head layer.
 */
const BASE_URL = "https://leadxkids.com";

export async function contentHubItemListJsonLd(): Promise<Record<string, unknown>> {
  const [{ learnTopics, learnBlogSlug }, { blogPosts }] = await Promise.all([
    import("@/content/learn"),
    import("@/content/blog"),
  ]);

  const items = [
    ...learnTopics.map((t) => ({ href: `/blog/${learnBlogSlug(t.slug)}`, name: t.keyword })),
    ...blogPosts.map(({ meta }) => ({ href: `/blog/${meta.slug}`, name: meta.title })),
  ];

  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      url: `${BASE_URL}${it.href}`,
      name: it.name,
    })),
  };
}
